/**
 * Product page, desktop (1024px+): one photo at a time in the center column.
 * The photo column is taller than the screen; its stage stays pinned and the
 * page scroll picks which photo shows. Photos cross-fade (CSS on data-active).
 * Picking a color scrolls smoothly to that color's photo (s-variant-media.js
 * calls gallery.stageShow).
 */
const gallery = document.querySelector('[data-product-gallery]');
const track = gallery?.closest('s-product-image-zoom');
if (gallery && track) {
  const desktop = window.matchMedia('(min-width: 1024px)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const counter = gallery.querySelector('[data-stage-current]');
  const slides = () => [...gallery.querySelectorAll('[data-gallery-slide]')];
  let frame = 0;

  const stickyTop = () => parseFloat(getComputedStyle(gallery).top) || 0;
  const range = () => Math.max(1, track.offsetHeight - gallery.offsetHeight);

  const setActive = (index) => {
    slides().forEach((slide, i) => slide.toggleAttribute('data-active', i === index));
    if (counter) counter.textContent = String(index + 1);
  };

  const update = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      if (!desktop.matches) return;
      const list = slides();
      if (list.length < 2) return;
      const progress = Math.min(1, Math.max(0, (stickyTop() - track.getBoundingClientRect().top) / range()));
      setActive(Math.round(progress * (list.length - 1)));
    });
  };

  gallery.stageShow = (slide) => {
    if (!desktop.matches) return false;
    const list = slides();
    const index = list.indexOf(slide);
    if (index < 0 || list.length < 2) return false;
    const trackTop = track.getBoundingClientRect().top + window.scrollY;
    const target = trackTop - stickyTop() + (index / (list.length - 1)) * range();
    window.scrollTo({ top: Math.max(0, target), behavior: reduce.matches ? 'auto' : 'smooth' });
    setActive(index);
    return true;
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  desktop.addEventListener('change', update);
  update();
}
